module.exports = __webpack_public_path__ + "img/memsic.8a02100a.jpg";